import { Form, Modal } from "react-bootstrap";
import "./Success_Modal_logOut.css";
import Green_Check_Lottie from "../../../Animation/green_check_lottie/Green_Check_Lottie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
const Success_Modal_LogOut = (props) => {
  return (
    <Modal
      className="Success_Modal Success_Modal_LogOut"
      size="sm"
      {...props}
      centered
    >
      <div className="absolute_div">
        <div className="animation_holder">
          <Green_Check_Lottie />
        </div>
      </div>

      {/* <div
        className="absolute_div"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <FontAwesomeIcon
          icon={faCircleCheck}
          style={{ color: "#28a745", fontSize: "80px" }}
        />
      </div> */}

      <Modal.Body>
        <p className="success_text">{props?.successText}</p>
      </Modal.Body>
    </Modal>
  );
};

export default Success_Modal_LogOut;
